// Haptic feedback utility
// Note: Vibration API works on Android and some other platforms, but NOT on iOS Safari

export const haptics = {
  // Check if vibration is supported
  isSupported: (): boolean => {
    return 'vibrate' in navigator;
  },

  // Light tap - for button presses, selections
  light: (): void => {
    if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  },

  // Medium tap - for confirmations, successful actions
  medium: (): void => {
    if (navigator.vibrate) {
      navigator.vibrate(25);
    }
  },

  // Heavy tap - for important actions, warnings
  heavy: (): void => {
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  },

  // Success pattern - for completed actions
  success: (): void => {
    if (navigator.vibrate) {
      navigator.vibrate([20, 50, 20]);
    }
  },

  // Error pattern - for errors, failed actions
  error: (): void => {
    if (navigator.vibrate) {
      navigator.vibrate([50, 30, 50, 30, 50]);
    }
  },

  // Warning pattern - for warnings, destructive actions
  warning: (): void => {
    if (navigator.vibrate) {
      navigator.vibrate([30, 50, 30]);
    }
  },

  // Custom pattern - array of [vibrate, pause, vibrate, pause, ...]
  pattern: (pattern: number[]): void => {
    if (navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  },
};